module.exports = __webpack_public_path__ + "img/credit-card.593c113b.svg";